/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestRegistPlanRequest
 */
export interface RequestRegistPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    addressLine?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    addressLine1: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistPlanRequest
     */
    baseId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistPlanRequest
     */
    boxCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistPlanRequest
     */
    boxHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistPlanRequest
     */
    boxLength?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistPlanRequest
     */
    boxWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistPlanRequest
     */
    boxWidth?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    countryCode: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistPlanRequest
     */
    groupNum: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof RequestRegistPlanRequest
     */
    itemIds: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    senderName: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    shipNum: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    shippedDate?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistPlanRequest
     */
    skuCount: number;
    /**
     * 
     * @type {string}
     * @memberof RequestRegistPlanRequest
     */
    stateOrProvinceCode: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistPlanRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRegistPlanRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestRegistPlanRequest interface.
 */
export function instanceOfRequestRegistPlanRequest(value: object): value is RequestRegistPlanRequest {
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('groupNum' in value) || value['groupNum'] === undefined) return false;
    if (!('itemIds' in value) || value['itemIds'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('senderName' in value) || value['senderName'] === undefined) return false;
    if (!('shipNum' in value) || value['shipNum'] === undefined) return false;
    if (!('skuCount' in value) || value['skuCount'] === undefined) return false;
    if (!('stateOrProvinceCode' in value) || value['stateOrProvinceCode'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestRegistPlanRequestFromJSON(json: any): RequestRegistPlanRequest {
    return RequestRegistPlanRequestFromJSONTyped(json, false);
}

export function RequestRegistPlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestRegistPlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'addressLine': json['address_line'] == null ? undefined : json['address_line'],
        'addressLine1': json['address_line1'],
        'baseId': json['base_id'],
        'boxCount': json['box_Count'] == null ? undefined : json['box_Count'],
        'boxHeight': json['box_height'] == null ? undefined : json['box_height'],
        'boxLength': json['box_length'] == null ? undefined : json['box_length'],
        'boxWeight': json['box_weight'] == null ? undefined : json['box_weight'],
        'boxWidth': json['box_width'] == null ? undefined : json['box_width'],
        'city': json['city'],
        'countryCode': json['country_code'],
        'groupNum': json['group_num'],
        'itemIds': json['item_ids'],
        'name': json['name'],
        'phoneNumber': json['phone_number'],
        'postalCode': json['postal_code'],
        'senderName': json['sender_name'],
        'shipNum': json['ship_num'],
        'shippedDate': json['shipped_date'] == null ? undefined : json['shipped_date'],
        'skuCount': json['sku_count'],
        'stateOrProvinceCode': json['state_or_province_code'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestRegistPlanRequestToJSON(json: any): RequestRegistPlanRequest {
    return RequestRegistPlanRequestToJSONTyped(json, false);
}

export function RequestRegistPlanRequestToJSONTyped(value?: RequestRegistPlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address_line': value['addressLine'],
        'address_line1': value['addressLine1'],
        'base_id': value['baseId'],
        'box_Count': value['boxCount'],
        'box_height': value['boxHeight'],
        'box_length': value['boxLength'],
        'box_weight': value['boxWeight'],
        'box_width': value['boxWidth'],
        'city': value['city'],
        'country_code': value['countryCode'],
        'group_num': value['groupNum'],
        'item_ids': value['itemIds'],
        'name': value['name'],
        'phone_number': value['phoneNumber'],
        'postal_code': value['postalCode'],
        'sender_name': value['senderName'],
        'ship_num': value['shipNum'],
        'shipped_date': value['shippedDate'],
        'sku_count': value['skuCount'],
        'state_or_province_code': value['stateOrProvinceCode'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

